import {
    setCasingCollapse,
    setCorrelationCollapse,
    setGasImpuritiesCollapse,
    setGasPropertyCollapse,
    setGasVolumeCollapse,
    setIprTypeCollapse,
    setLinerCollapse,
    setNotesCollapse,
    setOilPropertyCollapse,
    setOthersCollapse,
    setOthersTabCollapse,
    setPerformanceCurvesCollapse,
    setPowerConditionsCollapse,
    setProblemsCollapse,
    setProjectSummaryCollapse,
    setSettingDepthCollapse,
    setSummaryCollapse,
    setSurfaceConditionsCollapse,
    setSurfaceEquipmentCollapse,
    setSurfaceVoltageCollapse,
    setTdhCalculationsCollapse,
    setTubingCollapse,
    setWellInflowCalculationsCollapse,
    setWellIprCalculationsCollapse,
    setBasicWIFCollapse,
    setBasicIPRCollapse,
    setBasicTDHCollapse,
    setFluidCollapse,
    setNozzleDiameterCollapse,
    setThroatDiameterCollapse,
    setTubing1Collapse,
    setPowerFluidTypeCollapse,
    setTubing2Collapse,
    setBasicPerformanceCurveCollapse,

} from "../../../store/jetlift/collapse/collapseSlice";
import { useAppDispatch, useAppSelector } from "../../../store/hooks/StoreHooks";

const useJetliftCollapseFacade = () => {
    const dispatch = useAppDispatch();
    const { casingCollapse, linerCollapse, tubingCollapse, tubing1Collapse, tubing2Collapse, surfaceConditionsCollapse, iprTypeCollapse, settingDepthCollapse, fluidCollapse, oilPropertyCollapse, gasPropertyCollapse, gasVolumeCollapse, othersCollapse, correlationCollapse, powerConditionsCollapse, gasImpuritiesCollapse, problemsCollapse, othersTabCollapse, notesCollapse, nozzleDiameterCollapse, throatDiameterCollapse, powerFluidTypeCollapse } = useAppSelector((state) => state?.jetlift?.collapse);

    const updateBasicWIFCollapse = (payload: boolean) => {
        return dispatch(setBasicWIFCollapse(payload));
    };
    const updateBasicIPRCollapse = (payload: boolean) => {
        return dispatch(setBasicIPRCollapse(payload));
    };
    const updateBasicTDHCollapse = (payload: boolean) => {
        return dispatch(setBasicTDHCollapse(payload));
    };

    const updateCasingCollapse = (payload: boolean) => {
        return dispatch(setCasingCollapse(payload));
    };

    const updateTubingCollapse = (payload: boolean) => {
        return dispatch(setTubingCollapse(payload));
    };

    const updateTubing1Collapse = (payload: boolean) => {
        return dispatch(setTubing1Collapse(payload));
    };

    const updateTubing2Collapse = (payload: boolean) => {
        return dispatch(setTubing2Collapse(payload));
    };

    const updateLinerCollapse = (payload: boolean) => {
        return dispatch(setLinerCollapse(payload));
    };

    const updateSurfaceVoltageCollapse = (payload: boolean) => {
        return dispatch(setSurfaceVoltageCollapse(payload));
    };

    const updateSurfaceEquipmentCollapse = (payload: boolean) => {
        return dispatch(setSurfaceEquipmentCollapse(payload));
    };

    const updatePerformanceCurvesCollapse = (payload: boolean) => {
        return dispatch(setPerformanceCurvesCollapse(payload));
    };

    const updateSurfaceConditionsCollapse = (payload: boolean) => {
        return dispatch(setSurfaceConditionsCollapse(payload));
    };

    const updateIprTypeCollapse = (payload: boolean) => {
        return dispatch(setIprTypeCollapse(payload));
    };

    const updateSettingDepthCollapse = (payload: boolean) => {
        return dispatch(setSettingDepthCollapse(payload));
    };

    const updateFluidCollapse = (payload: boolean) => {
        return dispatch(setFluidCollapse(payload));
    };

    const updateOilPropertyCollapse = (payload: boolean) => {
        return dispatch(setOilPropertyCollapse(payload));
    };

    const updateGasPropertyCollapse = (payload: boolean) => {
        return dispatch(setGasPropertyCollapse(payload));
    };

    const updateGasVolumeCollapse = (payload: boolean) => {
        return dispatch(setGasVolumeCollapse(payload));
    };

    const updateOthersCollapse = (payload: boolean) => {
        return dispatch(setOthersCollapse(payload));
    };

    const updateCorrelationCollapse = (payload: boolean) => {
        return dispatch(setCorrelationCollapse(payload));
    };

    const updatePowerConditionsCollapse = (payload: boolean) => {
        return dispatch(setPowerConditionsCollapse(payload));
    };

    const updateGasImpuritiesCollapse = (payload: boolean) => {
        return dispatch(setGasImpuritiesCollapse(payload));
    };

    const updateProblemsCollapse = (payload: boolean) => {
        return dispatch(setProblemsCollapse(payload));
    };

    const updateOthersTabCollapse = (payload: boolean) => {
        return dispatch(setOthersTabCollapse(payload));
    };

    const updateNotesCollapse = (payload: boolean) => {
        return dispatch(setNotesCollapse(payload));
    };

    const updateNozzleDiaCollapse = (payload: boolean) => {
        return dispatch(setNozzleDiameterCollapse(payload));
    };

    const updateThroatDiaCollapse = (payload: boolean) => {
        return dispatch(setThroatDiameterCollapse(payload));
    };

    const updatePowerFluidTypeCollapse = (payload: boolean) => {
        return dispatch(setPowerFluidTypeCollapse(payload));
    };

    const updateSummaryCollapse = (payload: boolean) => {
        return dispatch(setSummaryCollapse(payload));
    };

    const updateProjectSummaryCollapse = (payload: boolean) => {
        return dispatch(setProjectSummaryCollapse(payload));
    };

    const updateWellInflowCalculationsCollapse = (payload: boolean) => {
        return dispatch(setWellInflowCalculationsCollapse(payload));
    };

    const updateWellIprCalculationsCollapse = (payload: boolean) => {
        return dispatch(setWellIprCalculationsCollapse(payload));
    };

    const updateTdhCalculationsCollapse = (payload: boolean) => {
        return dispatch(setTdhCalculationsCollapse(payload));
    };

    const updateBasicPerformanceCurveCollapse = (payload: boolean) => {
        return dispatch(setBasicPerformanceCurveCollapse(payload));
    };

    const getdefaultCollapse = (name: string) => {
        if (name === "Casing") return casingCollapse;
        else if (name === "Liner") return linerCollapse;
        else if (name === "Tubing") return tubingCollapse;
        else if (name === "Tubing - 1") return tubing1Collapse;
        else if (name === "Tubing - 2" || name?.includes("Tubing 2")) return tubing2Collapse;
        else if (name === "Surface conditions") return surfaceConditionsCollapse;
        else if (name === "IPR type") return iprTypeCollapse;
        else if (name === "Setting depth") return settingDepthCollapse;
        else if (name === "Fluid") return fluidCollapse;
        else if (name === "Oil property") return oilPropertyCollapse;
        else if (name === "Gas properties") return gasPropertyCollapse;
        else if (name === "Gas volume") return gasVolumeCollapse;
        else if (name === "Others") return othersCollapse;
        else if (name === "Correlations") return correlationCollapse;
        else if (name === "Power conditions") return powerConditionsCollapse;
        else if (name === "Gas impurities") return gasImpuritiesCollapse;
        else if (name === "Problems / Concerns") return problemsCollapse;
        else if (name === "Others") return othersTabCollapse;
        else if (name === "Notes") return notesCollapse;
        else if (name === "Nozzle") return nozzleDiameterCollapse;
        else if (name === "Throat") return throatDiameterCollapse;
        else if (name === "Power fluid type") return powerFluidTypeCollapse;
    };

    const handleCollapseChange = (key: boolean, name: string) => {
        if (name === "Casing") updateCasingCollapse(key);
        else if (name === "Liner") updateLinerCollapse(key);
        else if (name === "Tubing") updateTubingCollapse(key);
        else if (name === "Tubing - 1") updateTubing1Collapse(key);
        else if (name === "Tubing - 2" || name?.includes("Tubing 2")) updateTubing2Collapse(key);
        else if (name === "Surface conditions") updateSurfaceConditionsCollapse(key);
        else if (name === "IPR type") updateIprTypeCollapse(key);
        else if (name === "Setting depth") updateSettingDepthCollapse(key);
        else if (name === "Fluid") updateFluidCollapse(key);
        else if (name === "Oil property") updateOilPropertyCollapse(key);
        else if (name === "Gas properties") updateGasPropertyCollapse(key);
        else if (name === "Gas volume") updateGasVolumeCollapse(key);
        else if (name === "Others") updateOthersCollapse(key);
        else if (name === "Correlations") updateCorrelationCollapse(key);
        else if (name === "Power conditions") updatePowerConditionsCollapse(key);
        else if (name === "Gas impurities") updateGasImpuritiesCollapse(key);
        else if (name === "Problems / Concerns") updateProblemsCollapse(key);
        else if (name === "Others") updateOthersTabCollapse(key);
        else if (name === "Notes") updateNotesCollapse(key);
        else if (name === "Nozzle") updateNozzleDiaCollapse(key);
        else if (name === "Throat") updateThroatDiaCollapse(key);
        else if (name === "Power fluid type") updatePowerFluidTypeCollapse(key);
    };

    return {
        updateCasingCollapse,
        updateTubingCollapse,
        updateTubing1Collapse,
        updateTubing2Collapse,
        updateLinerCollapse,
        updateSurfaceVoltageCollapse,
        updateSurfaceEquipmentCollapse,
        updatePerformanceCurvesCollapse,
        updateSurfaceConditionsCollapse,
        updateIprTypeCollapse,
        updateSettingDepthCollapse,
        updateFluidCollapse,
        updateOilPropertyCollapse,
        updateGasPropertyCollapse,
        updateGasVolumeCollapse,
        updateOthersCollapse,
        updateCorrelationCollapse,
        updatePowerConditionsCollapse,
        updateGasImpuritiesCollapse,
        updateProblemsCollapse,
        updateOthersTabCollapse,
        updateNotesCollapse,
        updateNozzleDiaCollapse,
        updateThroatDiaCollapse,
        updateSummaryCollapse,
        updateProjectSummaryCollapse,
        updateWellInflowCalculationsCollapse,
        updateWellIprCalculationsCollapse,
        updateTdhCalculationsCollapse,
        updateBasicWIFCollapse,
        updateBasicIPRCollapse,
        updateBasicTDHCollapse,
        updateBasicPerformanceCurveCollapse,
        getdefaultCollapse,
        handleCollapseChange,
    };
};

export default useJetliftCollapseFacade;
